import {
  usePaymentInstallmentSetting,
  useSetPaymentInstallmentSetting,
} from "../../hooks/payment-installments.hooks";
import { SuccessToast } from "../toastMessage";
import style from "./PaymentInstallments.module.css";

/**
 * The on/off switch of the Payment Installments feature. On means an
 * applicant may pay a Demand Note in more than one receipt.
 */
export default function PaymentInstallmentToggle() {
  const { data: isOn = false, isLoading } = usePaymentInstallmentSetting();
  const { mutate: setSetting, isPending } = useSetPaymentInstallmentSetting();

  const onToggle = () =>
    setSetting(
      { enabled: !isOn },
      {
        onSuccess: () =>
          SuccessToast(
            isOn
              ? "Payment installments are now switched off"
              : "Payment installments are now switched on"
          ),
      }
    );

  return (
    <label className={style.toggleBtn}>
      <input
        type="checkbox"
        className={style.inputCheckbox}
        checked={isOn}
        disabled={isLoading || isPending}
        onChange={onToggle}
      />
      <span className={style.slider}></span>
    </label>
  );
}
